/**
 * This file is needed for Vite to work properly.
 * This allows us to use `import $ from 'jquery'` in our modules while still using WordPress's jQuery.
 * @see https://github.com/vitejs/vite/discussions/3744
 */
const $ = window.jQuery || window.$;
export default $;
export { $ as jQuery };
